export default __webpack_public_path__ + "static/media/SaleProcessIcon.3d2737f8.svg";